import { SET_AI_BID, SET_ALL_BIDS, SET_BID, SET_BIDS, SET_COOKIE, SET_DASHBOARD, SET_LOADING, SET_LOGIN, SET_PROJECTS, SET_PROJECTS_ID } from "../ConstAction";
const initialState = {};
export const ProjectData = (state = initialState, action) => {
  switch (action.type) {

    case SET_PROJECTS:
      return {
        ...state,
        result: action.response.data.result,
        loading: false,
      };
    case SET_PROJECTS_ID:
      let details = action.response.data;
      // Check for New API structure (nested inside result.projects array)
      if (details?.result?.projects?.[0]) {
        details = details.result.projects[0];
      }
      // Check for Old API structure (nested inside result object)
      else if (details?.result) {
        details = details.result;
      }
      // Otherwise, assume details is already normalized (from Requests.js)

      return {
        ...state,
        details: details,
        loading: false,
      };

    case SET_BID:
      return {
        ...state,
        bid: action.response.data.result,
        loading: false,
      };
    case SET_BIDS:
      return {
        ...state,
        bidsData: action.response.data,
        loading: false,
      };
    case SET_ALL_BIDS:
      return {
        ...state,
        allbidsData: action.response.data,
        loading: false,
      };
    case SET_AI_BID:
      return {
        ...state,
        generated: action.response.data,
        loading: false,
      };
    case SET_COOKIE:
      return {
        ...state,
        cookie: action.response.data,
        loading: false,
      };
    case SET_LOADING:
      return {
        loading: action.data,
      };
    default:
      return { ...state };
  }
};
